import { getD2CRefundPolicyRuleText } from '@orcar/common';
import {
  FinalConfirmModalInfoWrapper,
  FinalConfirmModalText,
  isMobileAtom,
  useGetRefundPolicies,
  useRecoil,
} from '@orcar/common-d2c';
import styled from 'styled-components';

const RuleConfirm = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const { data } = useGetRefundPolicies();

  return (
    <>
      {data?.data.map((refundPolicy) => (
        <FinalConfirmModalInfoWrapper isMobile={isMobile}>
          <FinalConfirmModalText key={refundPolicy.id}>
            {refundPolicy.name}
          </FinalConfirmModalText>
          <Ul isMobile={isMobile}>
            {refundPolicy.rules.map((rule, idx) => (
              <p key={idx}>{getD2CRefundPolicyRuleText(rule)}</p>
            ))}
          </Ul>
        </FinalConfirmModalInfoWrapper>
      ))}
      <FinalConfirmModalInfoWrapper isMobile={isMobile} hasList>
        <FinalConfirmModalText>2025년 성수기 안내</FinalConfirmModalText>
        <ul>
          <li>삼일절 연휴(2/27~3/3)</li>
          <li>근로자/어린이날/부처님오신날 연휴 (5/1~5/6)</li>
          <li>현충일 연휴(6/5~6/8)</li>
          <li>여름성수기(7/24~8/10)</li>
          <li>광복절 연휴 (8/14~8/17)</li>
          <li>개천절, 한글날, 추석 연휴(10/1~10/12)</li>
          <li>12월 성탄 및 연말연휴(12/24~26년1/1)</li>
        </ul>
      </FinalConfirmModalInfoWrapper>

      <FinalConfirmModalInfoWrapper isMobile={isMobile}>
        <FinalConfirmModalText>차종 변경 수수료</FinalConfirmModalText>
        <Ul isMobile={isMobile}>
          <p>차종 변경에 대한 문의는 예약실로 문의해주시기 바랍니다.</p>
          <p>
            초기 예약한 차종에 따라 등급별로 수수료 발생합니다. (신규
            예약하고자하는 차종 상관없음)
          </p>
          <p>차량 렌트 요금 차액은 별도로 청구됩니다.</p>
        </Ul>
      </FinalConfirmModalInfoWrapper>
      <Blank margin={4} />
      <FinalConfirmModalInfoWrapper isMobile={isMobile} hasList>
        <ul>
          <li>경차/소형 : 20,000원</li>
          <li>준중형/중형 : 30,000원</li>
          <li>고급/SUV : 40,000원</li>
          <li>수입/승합 : 50,000원</li>
          <li>슈퍼카 : 불가 (24시간 금액 청구)</li>
        </ul>
      </FinalConfirmModalInfoWrapper>
      {!isMobile && <Blank margin={44} />}
    </>
  );
};

export default RuleConfirm;

const Blank = styled.div<{ margin: number }>`
  ${({ margin }) => margin && `margin: ${margin}px;`}
`;

const Ul = styled.p<{ isMobile: boolean }>`
  & p {
    font-size: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
    font-weight: 400;
    line-height: ${({ isMobile }) => (isMobile ? '24px' : '27px')};
    color: ${({ theme }) => theme.COLOR.GREY_01};
  }
`;

const ListWrapper = styled.ul<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: ${({ isMobile }) => (isMobile ? '24px' : '27px')};
  margin-bottom: 20px;
`;
